module.exports = __webpack_public_path__ + "img/paper2.cd6f4ffd.svg";